// extracted by mini-css-extract-plugin
module.exports = {"cardContent":"EditUsuario_cardContent__x5vga","editUsuario":"EditUsuario_editUsuario__2Dz_0","form":"EditUsuario_form__VDE2B"};